import { gql } from '@apollo/client/core';
import { textBlockFragment } from '@core/services/graphql/fragments/text-block.fragment';
import { buttonBlockFragment } from '@core/services/graphql/fragments/button-block.fragment';
import { imageBlockFragment } from '@core/services/graphql/fragments/image-block.fragment';
import { bannerBlockFragment } from '../fragments/banner-block.fragment';
import { richTextBlockFragment } from '../fragments/rich-text-block.fragment';
import { videoEmbedBlockFragment } from '../fragments/video-embed-block.fragment';
import { galleryBlockFragment } from '../fragments/gallery-block.fragment';
import { accordionBlockFragment } from '../fragments/accordion-block.fragment';
import { htmlEmbedBlockFragment } from '../fragments/html-embed-block.fragment';
import { signpostBlockFragment } from '../fragments/signpost-block.fragment';
import { imageTextBlockFragment } from '../fragments/image-text-block.fragment';
import { downloadsBlockFragment } from '../fragments/downloads-block.fragment';
import { linkedLogosBlockFragment } from '../fragments/linked-logos.fragment';
import { audioEmbedBlockFragment } from '../fragments/audio-embed-block.fragment';

export const GET_PAGE_ASSEMBLY_NESTED = gql`
  query GetPageAssembly($slug: String!) {
    pageAssemblyCollection(limit: 1, where: { slug: $slug }) {
      items {
        pageTitle
        slug
        text
        metaDescription
        image {
          url
          title
        }
        blocksCollection(limit: 20) {
          items {
            __typename
            ...TextBlockFields
            ...ImageBlockFields
            ...ButtonBlockFields
            ...BannerBlockFields
            ...RichTextBlockFields
            ...VideoEmbedBlockFields
            ...GalleryBlockFields
            ...AccordionBlockFields
            ...HtmlEmbedBlockFields
            ...SignpostBlockFields
            ...ImageTextBlockFields
            ...DownloadsBlockFields
            ...LinkedLogosBlockFields
            ...AudioEmbedBlockFields
            ... on ContainerBlock {
              sys {
                id
              }
            }
          }
        }
      }
    }
  }
  ${textBlockFragment}
  ${imageBlockFragment}
  ${buttonBlockFragment}
  ${bannerBlockFragment}
  ${richTextBlockFragment}
  ${videoEmbedBlockFragment}
  ${galleryBlockFragment}
  ${accordionBlockFragment}
  ${htmlEmbedBlockFragment}
  ${signpostBlockFragment}
  ${imageTextBlockFragment}
  ${downloadsBlockFragment}
  ${linkedLogosBlockFragment}
  ${audioEmbedBlockFragment}
`;
